module.exports = __webpack_public_path__ + "static/media/image0.05e7ff42.jpeg";